import {h, Component} from 'preact';
export default class Cancel extends Component {
    render() {
        let {color, size} = this.props
        return (
            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42 42">
                <path fill={color} d="M4.58,39a1.51,1.51,0,0,1-1.37-2.15l2.8-6a18.07,18.07,0,1,1,6,5.66L5.07,38.9A1.47,1.47,0,0,1,4.58,39Zm-.35-2.34h0Zm8.13-3a1.23,1.23,0,0,1,.65.19,15.13,15.13,0,1,0-4.29-4,1.23,1.23,0,0,1,.11,1.24L6.76,35.49,12,33.73A1.23,1.23,0,0,1,12.36,33.66Z"/>
                <path fill={color} d="M15.94,12.9a8.18,8.18,0,0,1,5-1.81c3.37,0,6.08,2.25,6.08,5.54,0,2.62-2.2,4-3.91,4.93-.9.52-1.77.75-1.77,1.41s.56,1,.43,1.51-.5.82-1.4.82a2,2,0,0,1-2-2.19c0-1.53,1.1-2.48,2.49-3.29S24,18.15,24,16.65a2.73,2.73,0,0,0-3-2.71A6,6,0,0,0,18,15.06a2.56,2.56,0,0,1-1.48.66,1.6,1.6,0,0,1-1.39-1.47A1.67,1.67,0,0,1,15.94,12.9Z"/>
                <circle fill={color} cx="20.02" cy="30" r="1.97"/>
            </svg>
        );
    }
}



// WEBPACK FOOTER //
// ./components/SVGImages/HelpDesk.js